const ua = window.navigator.userAgent;
export const isIE = /MSIE|Trident/.test(ua);
